export const DataFeedRoutes = {
  DataFeeds: '/data-feeds',
  DataFeed: '/data-feed',
  CreateDataFeed: 'create',
  EditDataFeed: 'edit',
} as const;
